module.exports = __webpack_public_path__ + "img/scan 9.5470867f.jpg";